export default "__VITE_ASSET__ChvSekKV__"